import React from 'react'
import { Switch } from 'react-router-dom'
import PrivateRoute from './PrivateRoute'
import PreventedRoute from './PreventedRoute'
import {
  SplashPage,
  MainPage,
  LoginPage,
  SignupPage,
  UserInfoPage,
  UserPage,
  SearchResultsPage,
  PostDetailPage,
  PostWritePage,
} from '../pages'

const Router = () => {
  return (
    <Switch>
      <PrivateRoute path="/" exact component={SplashPage} />
      <PreventedRoute path="/main" exact component={MainPage} />
      <PrivateRoute path="/login" exact component={LoginPage} />
      <PrivateRoute path="/signup" exact component={SignupPage} />
      <PreventedRoute path="/userinfo" exact component={UserInfoPage} />
      <PreventedRoute path="/user" exact component={UserPage} />
      <PreventedRoute path="/user/:userId" exact component={UserPage} />
      <PreventedRoute path="/search" exact component={SearchResultsPage} />
      <PreventedRoute
        path="/search/:option/:keyword"
        exact
        component={SearchResultsPage}
      />
      <PreventedRoute
        path="/post/detail/:id"
        exact
        component={PostDetailPage}
      />
      <PreventedRoute path="/post/new" exact component={PostWritePage} />
      <PreventedRoute path="*" to="/" />
    </Switch>
  )
}

export default Router
